module.exports = __webpack_public_path__ + "img/11.bf408170.jpg";